import {
    Avatar,
    Box,
    ButtonGroup,
    Card,
    CardActions,
    CardContent,
    Grid,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import MDButton from "components/MDButton";
import Search from "examples/Search";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { openSnackbar } from "../../redux/slices/common";
import {
    closeCustomModalDialog,
    openCustomModalDialog,
    setModalLoader,
} from "../../redux/slices/modalSlice";
import { deleteCategory, fetchCategoriesList } from "../../redux/slices/category";
import { useDebounce } from "hooks/useDebounce";
import EditIcon from "common/customIcons/edit";
import DeleteIcon from "common/customIcons/delete";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import StatusText from "common/component/StatusText";
import MDBox from "components/MDBox";
import NoDataFound from "common/component/NoDataFound";
import CommonLoading from "components/common/CommonLoading";
import CategoryTabs from "./categoryTabs";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import { getPermissionsByMode } from "utilities/common";
import { hasSectionPermission } from "utilities/common";
import { getData } from "utilities/common";
import {  HYPERWOLF } from "utilities/constants";

export default function SubCategoriesGrid() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { categoriesList, loading = false } = useSelector((state) => state.category);
    const pageRef = useRef(0);
    const searchTermRef = useRef("");
    const [searchTerm, setSearchTerm] = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const categoryView = searchParams?.get("categoryView") || "grid";
    const adminsMode = getData("adminsMode");
    const isHyperWolf = JSON.parse(adminsMode) === HYPERWOLF

    const handleSearch = useDebounce(() => {
        pageRef.current = 0;
        searchFn();
    }, 500);


    const deleteHandler = (categoryId) => {
        dispatch(setModalLoader(true));
        dispatch(deleteCategory(categoryId))
            .unwrap()
            .then((res) => {
                showError(res?.message, "success");
                dispatch(closeCustomModalDialog());
                pageRef.current = 0;

                getCategories();

            })
            .catch((err) => {
                dispatch(setModalLoader(false));
                showError(err?.message, "error");
            });
    };



    const showError = (message, errortype) => {
        if (errortype === "success") {
            dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
        }
        if (errortype === "error") {
            dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
        }
    };
    const getCategories = () => {
        dispatch(
            fetchCategoriesList({
                skip: pageRef.current,
                limit: 100,
                userType: "admin",
                searchTerm: searchTermRef.current,
            })
        ).unwrap();
    };
    const searchHandler = (event) => {
        const { value } = event.target;
        setSearchTerm(value);
        searchTermRef.current = value;
        handleSearch(value);
    };
    const searchFn = () => {
        getCategories();
    };



    useEffect(() => {
        getCategories();
        setSearchParams({
            filter: searchParams.get("filter") ? searchParams.get("filter") : "manage_categories",
            categoryView: searchParams.get("categoryView") ? searchParams.get("categoryView") : "grid",
            categoryIds: searchParams.get("categoryIds") ? searchParams.get("categoryIds") : "",
            categoryTypes: searchParams.get("categoryTypes") ? searchParams.get("categoryTypes") : "",
            status: searchParams.get("status") ? searchParams.get("status") : "",
        });

    }, []);



    const cannabinoidViewHandler = (viewType = "") => {
        setSearchParams({
            filter: searchParams.get("filter") ? searchParams.get("filter") : "manage_categories",
            categoryView: viewType,
        });

    };

    let localUser = getData('login-user-info')
    if (localUser) {
        localUser = JSON.parse(localUser)
    }

    const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

    const canCreate = hasSectionPermission(permissionsForMode, "Manage Website", "Create");
    const canEdit = hasSectionPermission(permissionsForMode, "Manage Website", "Edit/Update");
    const canView = hasSectionPermission(permissionsForMode, "Manage Website", "View Only");
    const canDelete = hasSectionPermission(permissionsForMode, "Manage Website", "Delete");

    return (

        <Box p={{ xs: 2, sm: 3, lg: 4 }}>
            <CategoryTabs />
            <Grid container alignItems="center" rowSpacing={2} columnSpacing={2} mb={3}>
                <Grid item xs={12} sm={4}>
                    <Stack direction="row" gap={1} alignItems="center">
                        <Typography variant="h4">Sub Categories</Typography>
                        <Stack direction="row" gap={1} className="grid-list-view" ml={2}>

                            <Tooltip title="Grid View">
                                <div className="gl-view">
                                    <GridViewIcon
                                        onClick={() => {
                                            setSearchParams({
                                                filter: searchParams?.get("filter"),
                                                categoryView: "grid",
                                            });

                                            setSearchTerm("");
                                            searchTermRef.current = "";
                                            cannabinoidViewHandler("grid");
                                        }}
                                        color={categoryView === "grid" ? "primary" : ""}
                                    />
                                </div>
                            </Tooltip>

                            <Tooltip title="list View">
                                <div className="gl-view">
                                    <ViewListIcon
                                        onClick={() => {
                                            setSearchTerm("");
                                            searchTermRef.current = "";
                                            cannabinoidViewHandler("list");
                                            setSearchParams({
                                                filter: searchParams?.get("filter"),
                                                categoryView: "list",
                                            });
                                        }}
                                        color={categoryView === "list" ? "primary" : ""}
                                    />
                                </div>
                            </Tooltip>
                        </Stack>
                    </Stack>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Stack
                        direction="row"
                        justifyContent={{ xs: "start", sm: "end" }}
                        flexWrap="wrap"
                        alignItems="stretch"
                        gap={2}
                    >
                        <Search
                            placeholder="Search"
                            label=""
                            value={searchTerm}
                            onChange={searchHandler}
                        />
                        {
                            canCreate && !isHyperWolf &&
                            <MDButton
                                startIcon={<AddRoundedIcon fontSize="large" />}
                                variant="contained"
                                color="primary"
                                onClick={() => navigate("/categories/add")}
                            >
                                Add New Sub Category
                            </MDButton>
                        }

                    </Stack>
                </Grid>
            </Grid>

            <Grid container spacing={2} mb={4}>
                {categoriesList?.categories?.map((item, index) => (
                    <Grid item xs={12} sm={6} xl={4} key={index}>
                        <Card sx={{ boxShadow: 0, height: "100%", justifyContent: "space-between" }}>
                            <CardContent sx={{ p: 2.5 }}>
                                <Stack
                                    direction="row"
                                    alignItems="flex-start"
                                    justifyContent="space-between"
                                >
                                    <Box display="flex">
                                        <Avatar
                                            alt="No Image Found"
                                            src={isHyperWolf ? item?.categoryImage?.url ||  item?.bannerImage?.url :item?.categoryImage || item?.bannerImage?.url}   
                                            sx={{ width: 68, height: 68, borderRadius: 2 }}
                                        />
                                        <MDBox textAlign="left" ml={1.5} lineHeight={1}>
                                            <Typography
                                                variant="h5"
                                                fontSize={14}
                                                color="dark"
                                                fontWeight="semibold"
                                            >
                                                {item?.categoryName}
                                            </Typography>
                                            <Typography variant="p" fontSize={12} color="secondary">
                                                ID: {item?.categoryId}
                                            </Typography>
                                        </MDBox>
                                    </Box>
                                    <Box color="#24CA49" display="flex" alignItems="center">
                                        <StatusText status={item?.status?.toLowerCase()} />
                                    </Box>
                                </Stack>
                                <Box
                                    sx={{
                                        bgcolor: "#F2F3F7",
                                        px: 1.75,
                                        py: 1.25,
                                        borderRadius: 2.5,
                                        mt: 2.5,
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        fontSize={12}
                                        color="dark"
                                        className="truncate line-3"
                                    >
                                        {item?.description?.replace(/<\/?[^>]+(>|$)/g, "")}
                                    </Typography>
                                </Box>
                            </CardContent>
                            <CardActions sx={{ p: 0 }}>
                                <ButtonGroup className="card-footer-action" fullWidth variant="outlined">
                                    {
                                        canEdit &&
                                        <MDButton

                                            type="button"
                                            variant="outlined"
                                            color="dark"
                                            size="small"
                                            onClick={() => navigate(`/categories/${item?.categoryId}`)}
                                            startIcon={<EditIcon width="15px" height="15px" color="#0163FF" />}
                                        >
                                            Edit
                                        </MDButton>
                                    }
                                    {
                                        canDelete && !isHyperWolf &&
                                        <MDButton
                                            type="button"
                                            variant="outlined"
                                            color="dark"
                                            size="small"
                                            onClick={() => {
                                                dispatch(
                                                    openCustomModalDialog({
                                                        modalData: { deleteHandler, deleteId: item?.categoryId },
                                                        modal: "DELETE_MODAL",
                                                    })
                                                );
                                            }}
                                            startIcon={<DeleteIcon width="15px" height="15px" color="#FD4438" />}
                                        >
                                            Delete
                                        </MDButton>
                                    }

                                </ButtonGroup>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>


            {/* Show loading indicator */}
            {loading && <CommonLoading />}
        </Box>

    );
}
